import { Global } from '../common/global';
import * as $ from 'jquery';
import CryptoJS from 'crypto-js';
import jsSHA from 'jssha';

export class Server {
  constructor() {}

  send(_url, _success, _error, _data, _type, _dataType) {
    // return false
    const t = new Date().getTime();
    if (_data != null && !_data.fresh) {
      _data.t = t;
      const dAr = CryptoJS.enc.Utf8.parse(JSON.stringify(_data));
      const dr = CryptoJS.enc.Base64.stringify(dAr);
      const hd = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(t));
      const shaObj = new jsSHA('SHA-256', 'TEXT');
      shaObj.setHMACKey(Global.gameKey.substr(3, 8), 'TEXT');
      shaObj.update(`${hd}.${dr}`);
      const hmac = shaObj.getHMAC('HEX');
      const k1 = CryptoJS.enc.Utf8.parse(hmac);
      const k2 = CryptoJS.enc.Base64.stringify(k1);
      let text = '';
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const r1 = Math.floor(Math.random() * 6) + 1;
      const r2 = Math.floor(Math.random() * 7) + 2;
      for (let i = 0; i < r2; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      const f_str =
        String(r2) + String(r1) + k2.substr(0, r1) + text + k2.substr(r1);
      const out = `${hd}.${dr}.${f_str}`;

      var fullObj = {
        data: out,
        uniqID: Global.U_ID,
      };
    } else {
      fullObj = {};
      if (_data.fresh) {
        fullObj = _data;
      }
    }
    _type = _type == undefined ? 'POST' : _type;
    _dataType = _dataType == undefined ? null : _dataType;
    $.ajax({
      url: _url,
      datatype: _dataType,
      type: _type,
      data: fullObj,
      success: _success,
      error: _error,
    });
  }
}
